import { useEffect, useState } from 'react';

export * from './chartHooks';
export * from './hooks/usePlatformDetection';

/**
 * Hook that alerts clicks outside of the passed ref
 */
export const useOutsideAlerter = (ref: any, cb: any) => {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event: any) {
      if (ref.current && !ref.current.contains(event.target)) {
        cb();
      }
    }
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);
};

export const DESKTOP_WIDTH_LIMIT = 960;
export const TABLET_WIDTH_LIMIT = 600;

export const useScreen = () => {
  // Use state to store window dimensions
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    // Handler to call on window resize and orientation change
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    // Add event listeners
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);

    // Call handler right away so state gets updated with initial window size
    handleResize();

    // Remove event listeners on cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, []); // Empty array ensures effect is only run on mount and unmount

  const isTabletHook =
    windowSize.width <= DESKTOP_WIDTH_LIMIT && windowSize.width >= TABLET_WIDTH_LIMIT;

  return {
    isDesktopHook: windowSize.width > DESKTOP_WIDTH_LIMIT,
    isMobileHook: windowSize.width < TABLET_WIDTH_LIMIT,
    isTabletHook,
    width: windowSize.width,
    height: windowSize.height,
  };
};
